import { Panel } from "@/components/admin/AdminUI";

const sentence = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// One direction ("A sees B"): big Visible/Hidden, then every check with failing ones first.
export default function DirectionCard({ title, result, testId }) {
  const checks = [...(result?.checks || [])].sort((a, b) => Number(a.pass) - Number(b.pass));
  const failing = checks.filter((c) => !c.pass).length;
  return (
    <Panel className="p-6" data-testid={testId}>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div><h2 className="font-semibold">{title}</h2>
          <p className="cw-soft mt-1 text-sm">{failing ? `${failing} check${failing === 1 ? "" : "s"} failing` : "Every check passes"}</p></div>
        <span className={`inline-flex items-center gap-2.5 rounded-2xl px-5 py-3 text-2xl font-semibold tracking-tight ${result?.visible ? "cw-tone-success" : "cw-tone-error"}`} data-testid={`${testId}-verdict`}>
          <span className={`h-3 w-3 rounded-full ${result?.visible ? "bg-[var(--cw-success)]" : "bg-[var(--cw-error)]"}`} aria-hidden />{result?.visible ? "Visible" : "Hidden"}</span>
      </div>
      <ul className="mt-5 divide-y divide-border border-t border-border" data-testid={`${testId}-checks`}>
        {checks.map((c) => (
          <li key={c.check} className="flex items-start gap-3 py-3" data-testid={`${testId}-check`} data-pass={c.pass}>
            <span className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ${c.pass ? "bg-[var(--cw-success)]" : "bg-[var(--cw-error)]"}`} aria-label={c.pass ? "Pass" : "Fail"} role="img" />
            <div className="min-w-0"><p className={`text-sm ${c.pass ? "" : "font-semibold"}`}>{sentence(c.check)}</p>
              <p className="cw-soft text-sm">{c.reason}</p></div>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
